// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gap-1 {
  gap: 1rem;
}

.gap-03 {
  gap: 0.3rem;
}

.flex-two {
  flex: 2;
}

.font-16 {
  font-size: 16px;
}

.font-22 {
  font-size: 22px;
}

.sheet-importer .sheet-importer-header {
  margin: 0 -30px 1rem;
  padding: 0 30px 1rem;
  border-bottom: solid 1px rgba(74, 98, 136, 0.1);
}
.sheet-importer .sheet-importer-relations .label {
  color: rgb(27, 37, 95);
  white-space: nowrap;
}
.sheet-importer .sheet-importer-relations .label span {
  color: rgb(27, 37, 95);
  font-weight: 500;
}

.fields-linker-container {
  border-inline-end: dashed 1px rgba(74, 98, 136, 0.2);
}
.fields-linker-container ul {
  padding: 0px;
}
.fields-linker-container ul li {
  border: solid 1px #4678AA;
  padding: 5px;
  padding-inline-start: 8px;
  padding-inline-end: 40px;
  margin-top: 7px;
  margin-bottom: 8px;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  cursor: pointer;
  background-color: #FFFFFF;
  color: black;
  border-radius: 6px;
  text-overflow: ellipsis;
  list-style: none;
  /*overflow: hidden;*/
  position: relative;
  /*white-space: nowrap;*/
}
.fields-linker-container ul li > .icon-actions {
  position: absolute;
  top: calc(50% - 11px);
  inset-inline-end: 5px;
  height: 22px;
}
.fields-linker-container ul li > .icon-actions .fa-trash-alt,
.fields-linker-container ul li > .icon-actions .fa-times {
  position: relative;
  inset-inline-end: -8px;
  color: #4678AA;
  display: none;
}
.fields-linker-container ul li > .icon-actions .fa-trash-alt:hover,
.fields-linker-container ul li > .icon-actions .fa-times:hover {
  color: rgb(247, 95, 95);
}
.fields-linker-container ul li > .icon-actions .relation-joiner {
  width: 12px;
  height: 12px;
  border: solid 1px #4678AA;
  display: inline-block;
  border-radius: 6px;
  position: relative;
  top: 1px;
  background-color: white;
  inset-inline-end: -12px;
  z-index: 99;
  margin-inline-start: 5px;
}
.fields-linker-container ul li > .icon-actions .relation-joiner:hover {
  background-color: #17265D;
}
.fields-linker-container ul li > .icon-actions .relation-joiner:hover::after {
  font-family: "Font Awesome 6 Pro";
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
  font-weight: 400;
  content: "\\f30b";
  position: absolute;
  inset-inline-end: -18px;
  line-height: 10px;
  height: 10px;
  top: calc(50% - 5px);
  font-size: 20px;
  color: #17265D;
}
.fields-linker-container ul li.field-required {
  background-color: transparent;
  background: transparent;
  border-color: #5FB98F;
  color: rgb(27, 37, 95);
}
.fields-linker-container ul li:hover .icon-actions .fa-trash-alt,
.fields-linker-container ul li:hover .icon-actions .fa-times {
  display: inline-block;
}
.fields-linker-container ul li.connected .relation-joiner {
  background-color: #17265D !important;
}
.fields-linker-container .fields-linker-second-column ul li .relation-joiner {
  width: 12px;
  height: 12px;
  border: solid 1px #4678AA;
  display: inline-block;
  border-radius: 6px;
  position: relative;
  top: 1px;
  background-color: white;
  inset-inline-start: -14px;
  z-index: 99;
  margin-inline-end: -5px;
}

.audit-log-table-toolbar {
  background-color: transparent;
  padding-inline-start: 0;
  padding-inline-end: 0;
  padding-top: 0;
  padding-bottom: 0;
}
.audit-log-table-toolbar .search--table {
  color: rgb(27, 37, 95);
  background-color: #EAEDF2;
  border-radius: 6px;
}

.columns-toggler .dropdown-menu {
  padding: 0 !important;
  max-height: calc(100vh - 270px);
}
.columns-toggler .dropdown-menu.show {
  display: block;
  left: initial !important;
  inset-inline-start: 0px !important;
}
.columns-toggler .dropdown-menu button.dropdown-item.column-type-object i {
  font-weight: 900;
}
.columns-toggler .dropdown-menu button.dropdown-item.column-type-object ~ .dropdown-item:not(.column-type-object):not(:last-child) {
  padding-inline-start: 24px;
}
.columns-toggler .dropdown-menu::-webkit-scrollbar-thumb {
  background-color: config("color.gray.400");
}
.columns-toggler .col-status-icon {
  margin-inline-end: 10px;
  color: var(--check-icon-color, #4678AA);
}

.app-header .app-main-header .app-toolbar .header-notifications .toggle-automatic-deployment {
  display: flex;
}
.app-header .app-main-header .app-toolbar .header-notifications .toggle-automatic-deployment .toggle-icon {
  width: 22px;
  height: 14px;
  border-radius: 12px;
  font-family: initial;
  background-color: #b1b1b1;
  cursor: pointer;
}
.app-header .app-main-header .app-toolbar .header-notifications .toggle-automatic-deployment .toggle-icon::after {
  display: none;
}
.app-header .app-main-header .app-toolbar .header-notifications .toggle-automatic-deployment .toggle-icon::before {
  width: 10px;
  height: 10px;
  border-radius: 6px;
  content: "";
  position: absolute;
  top: 2px;
  inset-inline-start: 2px;
  transition-duration: 0.15s;
  background-color: rgba(255, 255, 255, 0.9);
}
.app-header .app-main-header .app-toolbar .header-notifications .toggle-automatic-deployment .toggle-icon.on {
  background-color: rgb(63, 172, 130);
}
.app-header .app-main-header .app-toolbar .header-notifications .toggle-automatic-deployment .toggle-icon.on::before {
  inset-inline-start: 10px;
}
.app-header .app-main-header .app-toolbar .header-logo-group {
  padding: 0;
  transition-duration: 0.2s;
}
.app-header .app-main-header .app-toolbar .header-logo-group * {
  transition-duration: 0.2s;
}
.app-header .app-main-header .app-toolbar .header-logo-group:hover {
  padding: 6px 8px;
  border: dashed 1px rgba(70, 120, 170, 0.4);
  border-radius: 6px;
  transition-duration: 0.2s;
}
.app-header .app-main-header .app-toolbar .header-logo-group:hover > div {
  transform: scale(0.9);
}
.app-header .app-main-header .app-toolbar .header-logo-group:hover .fa-cog {
  opacity: 0.7;
}
.app-header .app-main-header .app-toolbar .header-logo-group:hover .fa-cog:hover {
  opacity: 1;
}
.app-header .app-main-header .app-toolbar .header-logo-group .fa-cog {
  opacity: 0;
}
.app-header .app-main-header .app-toolbar .header-logo-group > div {
  display: flex;
  align-items: center;
  gap: 12px;
}
.app-header .app-main-header .app-toolbar .header-logo-group .grouped-items {
  display: inline-flex;
  flex-direction: column;
}
.app-header .app-main-header .app-toolbar .header-logo-group .grouped-items span.db-group-name {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
}
.app-header .app-main-header .app-toolbar .header-logo-group .grouped-items span.db-group-name:first-child {
  -webkit-line-clamp: 1;
}
.app-header .app-main-header .app-toolbar .header-logo-group .grouped-items span.db-group-name:last-child {
  -webkit-line-clamp: 2;
}
@media screen and (max-width: 520px) {
  .app-header .app-main-header .app-toolbar .header-logo-group .db-image {
    display: none;
  }
}

.text-color {
  color: rgb(27, 37, 95);
}

.page-name-bar.json-schema-editor-page, .page-name-bar.service-create {
  margin-top: -13px;
  margin-bottom: 10px;
}
.page-name-bar.json-schema-editor-page > .col-md-6:first-child:not(:empty), .page-name-bar.service-create > .col-md-6:first-child:not(:empty) {
  display: flex;
  align-items: center;
}
.page-name-bar.json-schema-editor-page button.btn.btn-celia span, .page-name-bar.service-create button.btn.btn-celia span {
  line-height: 12px;
}
.page-name-bar.json-schema-editor-page .dropdown:last-child button.btn-outline-danger, .page-name-bar.service-create .dropdown:last-child button.btn-outline-danger {
  margin-inline-end: 0;
}

.page-name > span {
  display: flex;
  align-items: center;
  width: 100%;
}
.page-name > span .jr-btn {
  margin-inline-start: 12px;
  border-color: rgb(27, 37, 95);
}
.page-name > span .jr-btn.round-add {
  height: 25px;
  padding: 0 5px !important;
  border-radius: 20px !important;
}
.page-name > span .jr-btn.round-add i {
  font-size: 13px;
  font-weight: 700;
  width: 12px;
}
.page-name > span .badge {
  margin: 0 18px;
}
.page-name .audit-log-heading .db-options-buttons {
  align-items: center;
  gap: 10px;
  line-height: 1;
}
.page-name .audit-log-heading .db-options-buttons .jr-menu-icon {
  width: auto !important;
  border: solid 1px rgba(70, 120, 170, 0.1);
  border-radius: 6px;
  padding: 0 !important;
  height: 32px !important;
}
.page-name .audit-log-heading .db-options-buttons .jr-menu-icon > span {
  padding: 0 0.8rem;
  color: rgba(70, 120, 170, 0.4);
  font-size: 13px;
  font-weight: 500;
}
.page-name .audit-log-heading .db-options-buttons .jr-menu-icon > span.tools-off {
  color: rgb(70, 120, 170);
  background-color: rgba(70, 120, 170, 0.1);
}
.page-name .audit-log-heading .db-options-buttons .jr-menu-icon.options--opened > span.tools-on {
  color: rgb(70, 120, 170);
  background-color: rgba(70, 120, 170, 0.1);
}
.page-name .audit-log-heading .db-options-buttons .jr-menu-icon.options--opened > span.tools-off {
  color: rgba(70, 120, 170, 0.4);
  background-color: transparent;
}
.page-name .audit-log-heading .db-options-buttons span {
  font-weight: 700;
  color: #3E73A5;
  font-size: 14px;
}
.page-name .audit-log-heading .db-options-buttons i.toggle-icon {
  color: #BABDCE;
  font-size: 20px;
  cursor: pointer;
}
.page-name .audit-log-heading .db-options-buttons i.toggle-icon.fa-toggle-on {
  color: #3fac82;
}
.page-name .audit-log-heading .db-options-buttons i.toggle-icon:hover {
  color: #a2bbd4;
}
.page-name .audit-log-heading .search--table {
  transition: all 0.2s;
  border-bottom: solid 1px #f4f4f4;
  color: white;
  display: inline-flex;
  width: auto;
  align-items: center;
  height: 32px;
  background-color: #EAEDF2;
  border-radius: 6px;
  padding: 0 12px;
}
.page-name .audit-log-heading .search--table:hover, .page-name .audit-log-heading .search--table:focus, .page-name .audit-log-heading .search--table:focus-within {
  transition: all 0.2s;
  opacity: 1;
}
.page-name .audit-log-heading .search--table input {
  border: none;
  display: flex;
  background: transparent;
  width: 100%;
  color: rgba(27, 37, 95, 0.8);
  font-size: 13px;
  font-weight: 500;
}
.page-name .audit-log-heading .search--table input:focus, .page-name .audit-log-heading .search--table input:active {
  outline: none;
}
.page-name .audit-log-heading .search--table i {
  display: inline-flex;
  color: rgba(27, 37, 95, 0.8);
  font-size: 14px;
}

.page-name-section .db-name-container {
  margin-bottom: 17px !important;
  text-transform: uppercase;
}
.page-name-section .db-name-container:empty {
  display: none;
}
.page-name-section .db-name-container:empty + .page-name-bar {
  --custom-bottom-margin: 17px;
}

.react-table .rt-table {
  background-color: #FFFFFF;
}
.react-table .rt-table .rt-thead {
  min-width: fit-content;
}
.react-table .rt-table .rt-thead .tr .th {
  display: flex;
}
.react-table .rt-table .rt-thead .tr .th.type-number {
  justify-content: flex-end;
}
.react-table .rt-table .rt-thead .tr .th.type-number .sorted-arrow {
  margin-inline-start: 6px;
}
.react-table .rt-table .rt-thead .tr .th.type-number .sorted-arrow:empty {
  display: none;
}
.react-table .rt-table .rt-thead .tr .th span.sorted-arrow {
  margin-inline-start: auto;
}
.react-table .rt-table .rt-thead .tr + .tr .th span:first-child {
  flex: auto;
  z-index: 99;
}
.react-table .rt-table .rt-thead .tr + .tr .th span.sorted-arrow {
  align-items: center;
  display: inline-flex;
  margin-inline-start: -6px;
}
.react-table .rt-table .rt-thead .tr + .tr .th.type-number {
  justify-content: flex-end;
}
.react-table .rt-table .rt-thead .tr + .tr .th.type-number span:first-child {
  flex: initial;
  text-align: end;
}
.react-table .rt-table .rt-thead .tr + .tr .th.type-number span.sorted-arrow {
  margin-inline-start: 6px !important;
}
.react-table .rt-table .rt-thead .tr + .tr .th.type-number span.sorted-arrow:empty {
  display: none;
}
.react-table .rt-table .rt-thead .tr:only-child .th {
  text-transform: initial;
}
.react-table .rt-table .rt-tbody > div {
  min-width: fit-content;
}
.react-table .rt-table .rt-tbody .tr.selected-row .td {
  background: #e5e5e5;
}
.react-table .rt-table .rt-tbody .tr .td:is(.type-array_of_file, .type-file) {
  display: flex;
  padding-block: 0;
  padding-inline: 0;
  align-items: center;
}
.react-table .rt-table .rt-tbody .tr .td:is(.type-array_of_file, .type-file):not(:has(button)) {
  padding-inline: 12px;
}
.react-table .rt-table .rt-tbody .tr .td.type-number {
  text-align: end;
  justify-content: flex-end;
}
.react-table .rt-table .rt-tbody .tr .td button.btn.btn-link {
  border: none;
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}
.react-table .rt-table .rt-tbody .tr .td.editgrid-cell button {
  align-items: center;
  display: inline-flex;
  line-height: 1;
  height: 21px !important;
  gap: 2px;
  margin-inline-start: -0.75rem;
}
.react-table .rt-table .rt-tbody .tr .td.editgrid-cell button + button {
  margin-inline-start: 0;
  padding: 0 0.5rem;
}
.react-table .rt-table .rt-tbody .tr .td.editgrid-cell button:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: black;
}
.react-table .rt-table .rt-tbody .tr:hover .table-row-actions-cell {
  opacity: 1;
}
.react-table .rt-table .rt-tfoot .tr .td {
  justify-content: flex-end;
}

.app-container.translations-page .app-main-content {
  min-height: 100px;
}
.app-container.translations-page .app-main-content .app-wrapper {
  height: calc(100% - 8px);
  flex-direction: row;
  display: flex;
}
.app-container.translations-page .app-main-content .app-wrapper .dashboard.translations-page {
  height: 100%;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  min-height: 100px;
}
.app-container.translations-page .app-main-content .app-wrapper .dashboard.translations-page .translations-table-container {
  flex: auto;
  display: flex;
  flex-direction: column;
  min-height: 100px;
  height: calc(100vh - 254px);
  padding-top: 24px;
}
.app-container.translations-page .app-main-content .app-wrapper .dashboard.translations-page .translations-table-container .translations-table {
  max-height: 100%;
}
.app-container.translations-page .app-main-content .app-wrapper .dashboard.translations-page .translations-table-container .translations-table .rt-table {
  max-height: calc(100% - 52px) !important;
  overflow-x: hidden !important;
}
.app-container.translations-page .app-main-content .app-wrapper .dashboard.translations-page .translations-table-container .translations-table .pagination {
  position: relative;
}
.app-container.translations-page .app-main-content .app-wrapper .dashboard.translations-page > .card {
  border: none;
  margin-top: 16px;
}
.app-container.translations-page .app-main-content .app-wrapper .dashboard.translations-page > .card > .card-header {
  padding: 0;
  min-height: 42px;
  background-color: transparent !important;
  border-bottom: none;
}
.app-container.translations-page .app-main-content .app-wrapper .dashboard.translations-page > .card > .card-header .nav-tabs {
  margin: 0;
  height: 100%;
}
.app-container.translations-page .app-main-content .app-wrapper .dashboard.translations-page > .card > .card-header .nav-tabs .nav-item {
  flex: initial;
}
.app-container.translations-page .app-main-content .app-wrapper .dashboard.translations-page > .card .tab-content {
  background: #f2f2f2;
  box-shadow: -50vw 0 0 #f2f2f2, 50vw 0 0 #f2f2f2;
  padding-top: 20px;
}

.mb-7 {
  margin-bottom: 5rem !important;
}

.collapse-panel-icon {
  margin-inline-start: var(--left-margin, auto);
}

.duplicate-db-button + .collapse-panel-icon {
  --left-margin: 0px;
}

.app-sidebar .side-nav {
  width: 100%;
  transition-duration: 0.3s;
  font-family: "Nunito Sans", sans-serif;
}
.app-sidebar .side-nav .sidebar-header {
  border: none;
}
.app-sidebar .side-nav .sidebar-header .instance-logo-container + div i {
  font-size: 20px;
}
.app-sidebar.group-opened .side-nav .drawer-dbs-groups .SplitPane .Pane2 {
  opacity: 1;
}
.app-sidebar.group-opened .modal-content > div > div[style="width: 25vw;"] {
  width: 50vw;
}
.app-sidebar:not(.group-opened) .drawer-dbs-groups .SplitPane .Pane1 {
  width: 100% !important;
}
.app-sidebar:not(.group-opened) .drawer-dbs-groups .SplitPane .Pane2 {
  opacity: 0;
}
.app-sidebar .sidebar-draggable-area > div {
  margin-bottom: 22px !important;
}
.app-sidebar ul.nav-menu.db-list-menu {
  height: max-content;
  padding-bottom: 22px;
}

.manage-version-drawer .card {
  margin-bottom: var(--custom-margin-bottom, 1rem);
  border: none;
}
.manage-version-drawer .card:last-child {
  --custom-margin-bottom: 0px;
}
.manage-version-drawer .card-header {
  background-color: var(--card-header-bg-color, #ECF1F5);
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.manage-version-drawer :where(.trash-button, .card-header) {
  line-height: 1;
}
.manage-version-drawer .accordion .card-body {
  padding: 0px;
}
.manage-version-drawer .accordion-collapse.show {
  padding-top: 10px;
  transition-duration: 0.15s;
}
.manage-version-drawer .service-item {
  border-bottom: solid 1px #DBDBDB;
  padding: 10px 24px;
  display: flex;
  gap: 10px;
  align-items: center;
}
.manage-version-drawer .service-item:last-child {
  border-bottom: none;
}
.manage-version-drawer .service-name {
  flex: 0 0 50%;
}
.manage-version-drawer .service-date {
  flex: 1;
}
.manage-version-drawer .service-action {
  margin-inline-end: -6px;
}

.modal.no-overlay, .modal.no-overlay + .modal-backdrop {
  bottom: initial;
}

.type-select-style [class*=-menu] {
  z-index: 10;
}

/* Advanced settings */
.json-schema-react-editor-adv-modal .all-advanced-visible-switch {
  display: flex;
}
.json-schema-react-editor-adv-modal .all-advanced-visible-switch button .ant-switch-inner {
  line-height: 1;
}
.json-schema-react-editor-adv-modal .modal-header {
  background-color: white !important;
  border: none !important;
}
.json-schema-react-editor-adv-modal .modal-header .modal-title > div {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.json-schema-react-editor-adv-modal .modal-content {
  border: none;
}
.json-schema-react-editor-adv-modal .modal-content .modal-body {
  height: calc(100vh - 180px);
  padding: 0px;
}
.json-schema-react-editor-adv-modal .modal-content .modal-body > div:not(.ant-tabs) {
  padding: 28px;
}
.json-schema-react-editor-adv-modal .modal-content .modal-body .other-row .ant-col .other-row {
  padding: 0;
}
.json-schema-react-editor-adv-modal .modal-content .modal-body .fk-settings-container .other-row {
  padding: 0px;
  margin-bottom: 0px;
}
.json-schema-react-editor-adv-modal .modal-content .modal-body .fk-settings .fk-item-checkbox {
  display: none;
}
.json-schema-react-editor-adv-modal .modal-content .modal-body .advanced-toggle-row {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 0px 0px 29px;
  margin: 0px;
}
.json-schema-react-editor-adv-modal .modal-content .modal-body .ant-row-flex {
  gap: 12px;
}
.json-schema-react-editor-adv-modal .modal-content .modal-body .ant-row-flex .ant-col {
  flex: 1;
}
.json-schema-react-editor-adv-modal .modal-content .modal-body .ant-row-flex .ant-col-2 {
  flex: 2;
}
.json-schema-react-editor-adv-modal .modal-content .modal-body .ant-row-flex .ant-col-3 {
  flex: 3;
}
.json-schema-react-editor-adv-modal .modal-content .modal-body .ant-row-flex .ant-col-8 {
  flex: 8;
  max-width: 33.33%;
}
.json-schema-react-editor-adv-modal .modal-content .modal-body .ant-row-flex .ant-col-11 {
  flex: 11;
}
.json-schema-react-editor-adv-modal .modal-content .modal-body .ant-row-flex .ant-col-12 {
  flex: 12;
  max-width: 50%;
}
.json-schema-react-editor-adv-modal .modal-content .modal-body .ant-row-flex .ant-col-16 {
  flex: 16;
  max-width: 66.66%;
}
.json-schema-react-editor-adv-modal .modal-content .modal-body .ant-row-flex .ant-col-24 {
  flex: 24;
}
.json-schema-react-editor-adv-modal .modal-content .modal-footer {
  background-color: white !important;
  border-top: none !important;
}
.json-schema-react-editor-adv-modal .modal-content .schema-trigger > button.ant-btn {
  border-radius: 6px !important;
  border: solid 1px #4678AA !important;
  color: #4678AA;
  background-color: white;
}
.json-schema-react-editor-adv-modal .modal-content .schema-trigger > button.ant-btn:hover {
  background-color: #4678AA;
  color: white;
}
.json-schema-react-editor-adv-modal .modal-content .schema-trigger .trigger-item {
  position: relative;
}
.json-schema-react-editor-adv-modal .modal-content .schema-trigger .trigger-item > div:first-child .ant-btn.danger {
  height: 28px;
  line-height: 20px;
  border-radius: 6px;
  border-color: #f44336;
  color: #f44336;
}
.json-schema-react-editor-adv-modal .modal-content .schema-trigger .trigger-item > div:first-child .ant-btn.danger:hover {
  background-color: #f44336;
  color: #FFFFFF;
}
.json-schema-react-editor-adv-modal .ant-col .other-label span {
  margin-bottom: 10px;
}

.advanced-toggle-row::before, .advanced-toggle-row::after {
  display: none;
}
.advanced-toggle-row .ant-switch {
  display: flex;
  align-items: center;
}

.fk-settings {
  flex-direction: column;
  align-items: flex-start;
  padding: 0px !important;
}

.fk-item-action {
  white-space: nowrap;
}

.delete-popover .popover {
  border-radius: 6px;
  border: 1px solid rgba(244, 67, 54, 0.2);
  box-shadow: 0 0.25rem 0.5rem rgba(244, 67, 54, 0.1);
  max-width: 500px;
}
.delete-popover .popover .arrow::before {
  border-bottom-color: rgba(244, 67, 54, 0.2);
}
.delete-popover .buttons-area {
  display: flex;
  gap: 10px;
}

.app-container.read-value-view-page .app-toolbar .topbar-logo-container {
  position: absolute;
  width: 100%;
  inset-inline-start: 0;
  justify-content: center;
}
.app-container .database-metadata {
  text-align: start;
}
.app-container .database-metadata .general-info.institution {
  font-size: 22px;
  margin-bottom: 8px;
  line-height: 1.2;
}
.app-container .database-metadata .general-info.description {
  font-size: 16px;
}
.app-container .field-tree:not(:first-child) {
  margin-top: 1rem;
}
.app-container .field-tree .data-read-value-field {
  margin-inline-start: 16px;
}
.app-container .field-tree .data-read-value-field .field-value {
  font-size: 24px;
  line-height: 1.2;
  font-weight: 500;
}
.app-container .field-tree .data-read-value-field .field-description {
  margin-top: 6px;
}

.row-history .json-data-view-object-item tbody tr td {
  padding: 0;
  min-height: 48px;
  --cell-vertical-align: middle;
}
.row-history .data-read-value-field {
  --left-margin: -24px;
  --right-margin: -24px;
  margin-inline-end: var(--right-margin);
  margin-bottom: -24px;
}
.row-history .field-value > .json-data-view-object-item > tbody > tr:not(.field-type-object) > td:first-child {
  padding-inline-start: 24px;
}
.row-history .field-value > .json-data-view-object-item > tbody > tr:not(.field-type-object) > td:last-child {
  padding-inline-end: 24px;
}
.row-history .field-value > .json-data-view-object-item > tbody > tr.field-type-object > .item-value-cell > .json-data-view-object-item > tbody > tr:not(.field-type-object) > td:last-child {
  padding-inline-end: 24px;
}
.row-history .field-history-icon-container {
  margin-inline-end: 0px !important;
}
.row-history .item-fieldname-cell label {
  padding-top: 0px;
}

.field-history-page-container {
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 1.5rem 1.5rem 3rem;
}
.field-history-page-container .react-table .rt-table {
  max-height: calc(100vh - 360px);
}

.field-tree-list,
.file-list {
  list-style: none;
  padding-inline-start: 0;
  margin-bottom: 16px;
}

.file-list {
  margin-bottom: 0;
}

.tree-level-icon {
  position: relative;
  top: -3px;
  margin-inline-end: 6px;
}

.field-name {
  margin-inline-start: 6px;
}

li:first-child .tree-level-icon {
  top: initial;
}
li:only-child .tree-level-icon {
  display: none;
}
li:last-child .field-name {
  font-weight: 600;
  margin-inline-end: 6px;
}

.data-view-list-group {
  margin-top: 24px;
}
.data-view-list-group .data-view-list-group-title {
  text-align: start;
  margin-bottom: 12px;
}
.data-view-list-group .data-view-list-group-title span {
  font: normal 600 16px/20px Open Sans, sans-serif;
  letter-spacing: -0.002em;
  color: #121212;
  font-weight: 600;
}
.data-view-list-group .data-view-list-group-title i {
  font-size: var(--button-icon-size, 13px);
  padding: 2px;
  min-width: var(--button-icon-square-size, 16px);
  min-height: var(--button-icon-square-size, 16px);
  --button-icon-size: 13px;
  margin-inline-end: 8px;
}
.data-view-list-group.list-collapsed .data-view-list-table {
  display: none;
}

.print-separator,
.print-button {
  display: none !important;
}

.sys-cuba .print-button {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./assets/src/css/themes/default/components/common.scss","webpack://./assets/src/css/themes/cuba/main.scss","webpack://./assets/src/css/themes/default/components/linker.scss","webpack://./assets/src/css/themes/default/variables.scss","webpack://./assets/src/css/themes/cuba/variables.scss","webpack://./assets/src/css/themes/default/components/toolbars.scss","webpack://./assets/src/css/themes/default/components/page-header.scss","webpack://./assets/src/css/themes/default/components/table.scss","webpack://./assets/src/css/themes/default/components/panel.scss","webpack://./assets/src/css/themes/default/components/drawer.scss","webpack://./assets/src/css/themes/default/components/modals.scss","webpack://./assets/src/css/themes/default/components/json-schema-builder.scss","webpack://./assets/src/css/themes/default/components/popover.scss","webpack://./assets/src/css/themes/default/components/data-read-value-page.scss","webpack://./assets/src/css/themes/default/components/groups.scss"],"names":[],"mappings":"AAGA;EACI,SAAA;ACDJ;;ADGA;EACI,WAAA;ACAJ;;ADEA;EACI,OAAA;ACCJ;;ADCA;EACI,eAbK;ACeT;;ADAA;EACI,eAfK;ACkBT;;AClBE;EACE,oBAAA;EACA,oBAAA;EACA,+CAAA;ADqBJ;ACjBI;EACE,sBCFO;EDGP,mBAAA;ADmBN;ACjBM;EACE,sBCNK;EDOL,gBAAA;ADmBR;;ACbA;EACE,oDAAA;ADgBF;ACdE;EACE,YAAA;ADgBJ;ACdI;EACE,yBAAA;EACA,YAAA;EACc,yBAAA;EACA,wBAAA;EACd,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,yBCTE;EDUF,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,uBAAA;ADgBN;ACdM;EACE,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;ADgBR;ACdQ;;EAEE,kBAAA;EACA,sBAAA;EACA,cC3CD;ED4CC,aAAA;ADgBV;ACdU;;EACE,uBAAA;ADiBZ;ACbQ;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,uBAAA;EACA,uBAAA;EACA,WAAA;EACA,wBAAA;ADeV;ACbU;EACE,yBCnDA;AFkEZ;ACbY;EACE,iCAAA;EACA,kCAAA;EACA,mCAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,cCtEF;AFqFZ;ACTM;EACE,6BAAA;EACA,uBAAA;EACA,qBE1GC;EF2GD,sBCrGK;AFgHb;ACNU;;EAEE,qBAAA;ADQZ;ACFQ;EACE,oCAAA;ADIV;ACKQ;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;EACA,uBAAA;ADHV;;AI3IA;EACI,6BAAA;EACA,uBAAA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;AJ8IJ;AI5II;EACI,sBFDK;EEEL,yBAAA;EACA,kBFiCS;AF6GjB;;AI1II;EACI,qBAAA;EACA,+BAAA;AJ6IR;AI3IQ;EACI,cAAA;EACA,wBAAA;EACA,kCAAA;AJ6IZ;AIxIoB;EACI,gBAAA;AJ0IxB;AItI4B;EACI,0BAAA;AJwIhC;AIjIQ;EACI,0CAAA;AJmIZ;AIhII;EACI,uBAAA;EACA,uCAAA;AJkIR;;AK3KgB;EACI,aAAA;AL8KpB;AK5KoB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;EACA,eAAA;AL8KxB;AK5KwB;EACI,aAAA;AL8K5B;AK5KwB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,uBAAA;EACA,0BAAA;EACA,0CAAA;AL8K5B;AK5KwB;EACI,mCHQZ;AFsKhB;AK5K4B;EACI,wBAAA;AL8KhC;AKxKY;EACI,UAAA;EACA,yBAAA;AL0KhB;AKxKgB;EACI,yBAAA;AL0KpB;AKxKgB;EACI,gBAAA;EACA,0CAAA;EACA,kBAAA;EACA,yBAAA;AL0KpB;AKxKoB;EACI,qBAAA;AL0KxB;AKxKoB;EACI,YAAA;AL0KxB;AKxKwB;EACI,UAAA;AL0K5B;AKtKgB;EACI,UAAA;ALwKpB;AKtKgB;EACI,aAAA;EACA,mBAAA;EACA,SAAA;ALwKpB;AKtKgB;EACI,oBAAA;EACA,sBAAA;ALwKpB;AKtKoB;EACI,oBAAA;EACA,gBAAA;EACA,4BAAA;ALwKxB;AKtKwB;EACI,qBAAA;ALwK5B;AKtKwB;EACI,qBAAA;ALwK5B;AKpKgB;EACI;IACI,aAAA;ELsKtB;AACF;;AKhKA;EACI,sBH3FS;AF8Pb;;AKhKI;EAEI,iBAAA;EACA,mBAAA;ALkKR;AK9JgB;EACI,aAAA;EACA,mBAAA;ALgKpB;AKzJoB;EACI,iBAAA;AL2JxB;AKnJoB;EACI,oBAAA;ALqJxB;;AK7II;EACI,aAAA;EACA,mBAAA;EACA,WAAA;ALgJR;AK9IQ;EACI,yBAAA;EAEA,6BAAA;AL+IZ;AK7IY;EACI,YAAA;EACA,yBAAA;EACA,8BAAA;AL+IhB;AK7IgB;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AL+IpB;AK3IQ;EACI,cAAA;AL6IZ;AKzIQ;EACI,mBAAA;EACA,SAAA;EACA,cAAA;AL2IZ;AKzIY;EACI,sBAAA;EACA,yCAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;AL2IhB;AKzIgB;EACI,iBAAA;EACA,8BHzJL;EG0JK,eAAA;EACA,gBAAA;AL2IpB;AKzIoB;EACI,wBHlKR;EGmKQ,yCHlKT;AF6Sf;AKtIwB;EACI,wBHzKZ;EG0KY,yCHzKb;AFiTf;AKtIwB;EACI,8BHzKb;EG0Ka,6BAAA;ALwI5B;AKnIY;EACI,gBAAA;EACA,cAAA;EACA,eAAA;ALqIhB;AKnIY;EACI,cAAA;EACA,eAAA;EACA,eAAA;ALqIhB;AKnIgB;EACI,cAAA;ALqIpB;AKnIgB;EACI,cAAA;ALqIpB;AKjIQ;EACI,oBAAA;EACA,gCAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;ALmIZ;AKjIY;EAGI,oBAAA;EACA,UAAA;ALiIhB;AK/HY;EACI,YAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,4BHvOA;EGwOA,eAAA;EACA,gBAAA;ALiIhB;AK/HgB;EAEI,aAAA;ALgIpB;AK7HY;EACI,oBAAA;EACA,4BHlPA;EGmPA,eAAA;AL+HhB;;AKzHI;EACI,8BAAA;EACA,yBAAA;AL4HR;AK1HQ;EACI,aAAA;AL4HZ;AK1HY;EACI,4BAAA;AL4HhB;;AMpYI;EACI,yBJ2BA;AF4WR;AMrYQ;EACI,sBAAA;ANuYZ;AMrYgB;EACI,aAAA;ANuYpB;AMrYoB;EACI,yBAAA;ANuYxB;AMrYwB;EACI,wBAAA;ANuY5B;AMrY4B;EACI,aAAA;ANuYhC;AMlYwB;EACI,yBAAA;ANoY5B;AM7X4B;EACI,UAAA;EACA,WAAA;AN+XhC;AM7X4B;EACI,mBAAA;EACA,oBAAA;EACA,yBAAA;AN+XhC;AM5XwB;EACI,yBAAA;AN8X5B;AM3XgC;EACI,aAAA;EACA,eAAA;AN6XpC;AM3XgC;EACI,mCAAA;AN6XpC;AM3XoC;EACI,aAAA;AN6XxC;AMrXoB;EACI,uBAAA;ANuXxB;AMjXY;EACI,sBAAA;ANmXhB;AM/WoB;EACI,mBAAA;ANiXxB;AM7WoB;EACI,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AN+WxB;AM7WwB;EACI,oBAAA;AN+W5B;AM3WoB;EACI,eAAA;EACA,yBAAA;AN6WxB;AMzW4B;EACI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AN2WhC;AMtWwB;EACI,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,uBAAA;EACA,QAAA;EACA,6BAAA;ANwW5B;AMtW4B;EACI,sBAAA;EACA,iBAAA;ANwWhC;AMtW4B;EACI,qCJnFtB;EIoFsB,YJvFxB;AF+bR;AMlWoB;EACI,UAAA;ANoWxB;AM7VgB;EACI,yBAAA;AN+VpB;;AMvVQ;EACI,iBAAA;AN0VZ;AMxVY;EACI,wBAAA;EACA,mBAAA;EACA,aAAA;AN0VhB;AMxVgB;EACI,YAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;AN0VpB;AMxVoB;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,iBAAA;AN0VxB;AMxVwB;EACI,gBAAA;AN0V5B;AMxV4B;EACI,wCAAA;EACA,6BAAA;AN0VhC;AMvV4B;EACI,kBAAA;ANyVhC;AMrVoB;EACI,YAAA;EACA,gBAAA;ANuVxB;AMrVwB;EACI,UAAA;EACA,gBAAA;EACA,wCAAA;EACA,mBAAA;ANuV5B;AMrV4B;EACI,SAAA;EACA,YAAA;ANuVhC;AMrVgC;EACI,aAAA;ANuVpC;AMnVwB;EACI,mBAAA;EACA,+CAAA;EACA,iBAAA;ANqV5B;;AO5hBA;EACI,8BAAA;AP+hBJ;;AO7hBA;EACI,6CAAA;APgiBJ;;AO9hBA;EACI,kBAAA;APiiBJ;;AQviBI;EACI,WAAA;EACA,yBAAA;EACA,sCAAA;AR0iBR;AQxiBQ;EACI,YAAA;AR0iBZ;AQtiBoB;EACI,eAAA;ARwiBxB;AQ9hBoB;EACI,UAAA;ARgiBxB;AQxhBoB;EACI,WAAA;AR0hBxB;AQjhBgB;EACI,sBAAA;ARmhBpB;AQjhBgB;EACI,UAAA;ARmhBpB;AQ7gBQ;EACI,8BAAA;AR+gBZ;AQ5gBI;EACI,mBAAA;EACA,oBAAA;AR8gBR;;AQzgBI;EACI,gDAAA;EACA,YAAA;AR4gBR;AQ1gBQ;EACI,2BAAA;AR4gBZ;AQzgBI;EACI,sDAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;AR2gBR;AQzgBI;EACI,cAAA;AR2gBR;AQxgBQ;EACI,YAAA;AR0gBZ;AQvgBI;EACI,iBAAA;EACA,0BAAA;ARygBR;AQvgBI;EACI,gCAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;ARygBR;AQvgBQ;EACI,mBAAA;ARygBZ;AQtgBI;EACI,aAAA;ARwgBR;AQtgBI;EACI,OAAA;ARwgBR;AQtgBI;EACI,uBAAA;ARwgBR;;ASpnBI;EAEI,eAAA;ATsnBR;;AUxnBI;EACI,WAAA;AV2nBR;;AUvnBA,sBAAA;AAEI;EACI,aAAA;AVynBR;AUtnBY;EACI,cAAA;AVwnBhB;AUpnBI;EACI,kCAAA;EACA,uBAAA;AVsnBR;AUnnBY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AVqnBhB;AUjnBI;EACI,YAAA;AVmnBR;AUjnBQ;EACI,2BAAA;EACA,YAAA;AVmnBZ;AUjnBY;EACI,aAAA;AVmnBhB;AU/mBoB;EACI,UAAA;AVinBxB;AU7mBY;EACI,YAAA;EACA,kBAAA;AV+mBhB;AU5mBgB;EACI,aAAA;AV8mBpB;AU3mBY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,WAAA;AV6mBhB;AU3mBY;EACI,SAAA;AV6mBhB;AU3mBgB;EACI,OAAA;AV6mBpB;AU3mBgB;EACI,OAAA;AV6mBpB;AU3mBgB;EACI,OAAA;AV6mBpB;AU3mBgB;EACI,OAAA;EACA,iBAAA;AV6mBpB;AU3mBgB;EACI,QAAA;AV6mBpB;AU3mBgB;EACI,QAAA;EACA,cAAA;AV6mBpB;AU3mBgB;EACI,QAAA;EACA,iBAAA;AV6mBpB;AU3mBgB;EACI,QAAA;AV6mBpB;AUzmBQ;EACI,kCAAA;EACA,2BAAA;AV2mBZ;AUxmBY;EACI,6BAAA;EACA,oCAAA;EACA,cAAA;EACA,uBAAA;AV0mBhB;AUxmBgB;EACI,yBAAA;EACA,YAAA;AV0mBpB;AUvmBY;EACI,kBAAA;AVymBhB;AUtmBoB;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;AVwmBxB;AUtmBwB;EACI,yBAAA;EACA,cAAA;AVwmB5B;AU/lBY;EACI,mBAAA;AVimBhB;;AU3lBI;EAEI,aAAA;AV6lBR;AU3lBI;EACI,aAAA;EACA,mBAAA;AV6lBR;;AU1lBA;EACI,sBAAA;EACA,uBAAA;EACA,uBAAA;AV6lBJ;;AU3lBA;EACI,mBAAA;AV8lBJ;;AWtvBI;EACI,kBAAA;EACA,wCAAA;EACA,mDAAA;EACA,gBAAA;AXyvBR;AWtvBY;EACI,2CT2BC;AF6tBjB;AWpvBI;EACI,aAAA;EACA,SAAA;AXsvBR;;AYnwBY;EACI,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,uBAAA;AZswBhB;AYlwBI;EACI,iBAAA;AZowBR;AYjwBY;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;AZmwBhB;AYjwBY;EACI,eAAA;AZmwBhB;AY9vBQ;EACI,gBAAA;AZgwBZ;AY9vBQ;EACI,yBAAA;AZgwBZ;AY9vBY;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AZgwBhB;AY9vBY;EACI,eAAA;AZgwBhB;;AYvvBgB;EACI,UAAA;EACA,gBAAA;EACA,6BAAA;AZ0vBpB;AYrvBI;EACI,oBAAA;EACA,qBAAA;EACA,sCAAA;EACA,oBAAA;AZuvBR;AYhvBwB;EACI,0BAAA;AZkvB5B;AYhvBwB;EACI,wBAAA;AZkvB5B;AY7uBoB;EACI,wBAAA;AZ+uBxB;AYzuBI;EACI,iCAAA;AZ2uBR;AYzuBI;EACI,gBAAA;AZ2uBR;;AYxuBA;EACI,0CAAA;EACA,mBAAA;EACA,2BAAA;AZ2uBJ;AYzuBI;EACI,+BAAA;AZ2uBR;;AYxuBA;;EAEI,gBAAA;EACA,uBAAA;EACA,mBAAA;AZ2uBJ;;AYzuBA;EACI,gBAAA;AZ4uBJ;;AY1uBA;EACI,kBAAA;EACA,SAAA;EACA,sBAAA;AZ6uBJ;;AY3uBA;EACI,wBAAA;AZ8uBJ;;AY1uBQ;EACI,YAAA;AZ6uBZ;AYzuBQ;EACI,aAAA;AZ2uBZ;AYvuBQ;EACI,gBAAA;EACA,sBAAA;AZyuBZ;;Aa12BA;EACI,gBAAA;Ab62BJ;Aa52BI;EAEI,iBAAA;EACA,mBAAA;Ab62BR;Aa52BQ;EACI,gDAAA;EACA,wBAAA;EACA,cAAA;EACA,gBAAA;Ab82BZ;Aa52BQ;EACI,wCAAA;EACA,YAAA;EACA,+CAAA;EACA,gDAAA;EACA,wBAAA;EACA,sBAAA;Ab82BZ;Aaz2BQ;EACI,aAAA;Ab22BZ;;AAh4BA;;EAEI,wBAAA;AAm4BJ;;AAh4BA;EACI,wBAAA;AAm4BJ","sourcesContent":["$font16: 16px;\r\n$font22: 22px;\r\n\r\n.gap-1 {\r\n    gap: 1rem;\r\n}\r\n.gap-03 {\r\n    gap: 0.3rem;\r\n}\r\n.flex-two {\r\n    flex: 2;\r\n}\r\n.font-16 {\r\n    font-size: $font16;\r\n}\r\n.font-22 {\r\n    font-size: $font22;\r\n}","@import './variables.scss';\n@import '../default/components/components.scss';\n\n.print-separator,\n.print-button {\n    display: none !important;\n}\n\n.sys-cuba .print-button {\n    display: none !important;\n}",".sheet-importer {\r\n  .sheet-importer-header {\r\n    margin: 0 -30px 1rem;\r\n    padding: 0 30px 1rem;\r\n    border-bottom: solid 1px $light-gray-a;\r\n  }\r\n\r\n  .sheet-importer-relations {\r\n    .label {\r\n      color: $text-color;\r\n      white-space: nowrap;\r\n\r\n      span {\r\n        color: $text-color;\r\n        font-weight: 500;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.fields-linker-container {\r\n  border-inline-end: dashed 1px $light-gray-b;\r\n\r\n  ul {\r\n    padding: 0px;\r\n\r\n    li {\r\n      border: solid 1px $blue-a;\r\n      padding: 5px;\r\n                    padding-inline-start: 8px;\r\n                    padding-inline-end: 40px;\r\n      margin-top: 7px;\r\n      margin-bottom: 8px;\r\n      user-select: none;\r\n      -moz-user-select: none;\r\n      -webkit-user-select: none;\r\n      -ms-user-select: none;\r\n      cursor: pointer;\r\n      background-color: $white;\r\n      color: black;\r\n      border-radius: 6px;\r\n      text-overflow: ellipsis;\r\n      list-style: none;\r\n      /*overflow: hidden;*/\r\n      position: relative;\r\n      /*white-space: nowrap;*/\r\n\r\n      > .icon-actions {\r\n        position: absolute;\r\n        top: calc(50% - 11px);\r\n        inset-inline-end: 5px;\r\n        height: 22px;\r\n\r\n        .fa-trash-alt,\r\n        .fa-times {\r\n          position: relative;\r\n          inset-inline-end: -8px;\r\n          color: $blue-a;\r\n          display: none;\r\n\r\n          &:hover {\r\n            color: rgb(247, 95, 95);\r\n          }\r\n        }\r\n\r\n        .relation-joiner {\r\n          width: 12px;\r\n          height: 12px;\r\n          border: solid 1px $blue-a;\r\n          display: inline-block;\r\n          border-radius: 6px;\r\n          position: relative;\r\n          top: 1px;\r\n          background-color: white;\r\n          inset-inline-end: -12px;\r\n          z-index: 99;\r\n          margin-inline-start: 5px;\r\n\r\n          &:hover {\r\n            background-color: $dark-blue;\r\n\r\n            &::after {\r\n              font-family: \"Font Awesome 6 Pro\";\r\n              -moz-osx-font-smoothing: grayscale;\r\n              -webkit-font-smoothing: antialiased;\r\n              display: inline-block;\r\n              font-style: normal;\r\n              font-variant: normal;\r\n              text-rendering: auto;\r\n              line-height: 1;\r\n              font-weight: 400;\r\n              content: \"\\f30b\";\r\n              position: absolute;\r\n              inset-inline-end: -18px;\r\n              line-height: 10px;\r\n              height: 10px;\r\n              top: calc(50% - 5px);\r\n              font-size: 20px;\r\n              color: $dark-blue;\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      &.field-required {\r\n        background-color: transparent;\r\n        background: transparent;\r\n        border-color: $orange;\r\n        color: $text-color;\r\n      }\r\n\r\n      &:hover {\r\n        .icon-actions {\r\n          .fa-trash-alt,\r\n          .fa-times {\r\n            display: inline-block;\r\n          }\r\n        }\r\n      }\r\n\r\n      &.connected {\r\n        .relation-joiner {\r\n          background-color: $dark-blue !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .fields-linker-second-column {\r\n    ul {\r\n      li {\r\n        .relation-joiner {\r\n          width: 12px;\r\n          height: 12px;\r\n          border: solid 1px $blue-a;\r\n          display: inline-block;\r\n          border-radius: 6px;\r\n          position: relative;\r\n          top: 1px;\r\n          background-color: white;\r\n          inset-inline-start: -14px;\r\n          z-index: 99;\r\n          margin-inline-end: -5px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}","@use 'sass:map';\r\n\r\n@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;600;700&display=swap');\r\n\r\n$font-family-sans-serif: 'Nunito Sans', sans-serif;\r\n$orange: rgba(255, 137, 93, 1);\r\n$orange-08: rgba(255, 137, 93, 0.8);\r\n$text-color: rgba(27, 37, 95, 1);\r\n$text-color-80: rgba(27, 37, 95, 0.8);\r\n$light-gray-a: rgba(74, 98, 136, 0.1);\r\n$light-gray-b: rgba(74, 98, 136, 0.2);\r\n$light-gray-c: #F5F8FB;\r\n$light-gray-d: #ECECEE;\r\n$light-gray-e: rgb(242, 242, 242);\r\n$blue-a: #4678AA;\r\n$blue-b: rgba(70, 120, 170, 1);\r\n$blue-b-08: rgba(70, 120, 170, 0.8);\r\n$blue-c: #9cbdce;\r\n$gray-blue: #DAE4EE;\r\n$gray-blue-100: rgba(70, 120, 170, 1);\r\n$gray-blue-10: rgba(70, 120, 170, 0.1);\r\n$gray-blue-20: rgba(70, 120, 170, 0.2);\r\n$gray-blue-5: rgba(70, 120, 170, 0.05);\r\n$gray-blue-40: rgba(70, 120, 170, 0.4);\r\n$black-transparent-10: rgba(0, 0, 0, 0.1);\r\n$light-blue: #EBF1F6;\r\n$light-blue-a: #EAEDF2;\r\n$light-purple: #eaebf3;\r\n$dark-blue: #17265D;\r\n$white: #FFFFFF;\r\n$dark-gray-a: #222222;\r\n$black: black;\r\n$black-30: rgba(0, 0, 0, 0.3);\r\n$black-10: rgba(0, 0, 0, 0.1);\r\n$black-5: rgba(0, 0, 0, 0.05);\r\n$red-color-a: rgb(244, 67, 54);\r\n$red-color-a-10: rgba(244, 67, 54, 0.1);\r\n$red-color-a-20: rgba(244, 67, 54, 0.2);\r\n$green-color-a: rgba(63, 172, 130, 1);\r\n$green-color-a-08: rgba(63, 172, 130, 0.8);\r\n$modal-header: #F6FAFD;\r\n$modal-header-bottom-border: #EBECEE;\r\n\r\n$rounded-corner: 6px;","@import \"../default/variables.scss\";\r\n$orange: #5FB98F;",".audit-log-table-toolbar {\r\n    background-color: transparent;\r\n    padding-inline-start: 0;\r\n    padding-inline-end: 0;\r\n    padding-top: 0;\r\n    padding-bottom: 0;\r\n\r\n    .search--table {\r\n        color: $text-color;\r\n        background-color: #EAEDF2;\r\n        border-radius: $rounded-corner;\r\n    }\r\n}\r\n.columns-toggler {\r\n    .dropdown-menu {\r\n        padding: 0 !important;\r\n        max-height: calc(100vh - 270px);\r\n\r\n        &.show {\r\n            display: block;\r\n            left: initial !important;\r\n            inset-inline-start: 0px !important;\r\n        }\r\n        button {\r\n            &.dropdown-item {\r\n                &.column-type-object {\r\n                    i {\r\n                        font-weight: 900;\r\n                    }\r\n                    & ~ .dropdown-item {\r\n                        &:not(.column-type-object) {\r\n                            &:not(:last-child) {\r\n                                padding-inline-start: 24px;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        &::-webkit-scrollbar-thumb {\r\n            background-color: config(\"color.gray.400\");\r\n        }\r\n    }\r\n    .col-status-icon {\r\n        margin-inline-end: 10px;\r\n        color: var(--check-icon-color, $blue-a);\r\n    }\r\n}",".app-header {\r\n    .app-main-header {\r\n        .app-toolbar {\r\n            .header-notifications {\r\n                .toggle-automatic-deployment {\r\n                    display: flex;\r\n                    \r\n                    .toggle-icon {\r\n                        width: 22px;\r\n                        height: 14px;\r\n                        border-radius: 12px;\r\n                        font-family: initial;\r\n                        background-color: #b1b1b1;\r\n                        cursor: pointer;\r\n                        \r\n                        &::after {\r\n                            display: none;\r\n                        }\r\n                        &::before {\r\n                            width: 10px;\r\n                            height: 10px;\r\n                            border-radius: 6px;\r\n                            content: \"\";\r\n                            position: absolute;\r\n                            top: 2px;\r\n                            inset-inline-start: 2px;\r\n                            transition-duration: 0.15s;\r\n                            background-color: rgba(255, 255, 255, 0.9);\r\n                        }\r\n                        &.on {\r\n                            background-color: $green-color-a;\r\n\r\n                            &::before {\r\n                                inset-inline-start: 10px;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            .header-logo-group {\r\n                padding: 0;\r\n                transition-duration: 0.2s;\r\n\r\n                * {\r\n                    transition-duration: 0.2s;\r\n                }\r\n                &:hover {\r\n                    padding: 6px 8px;\r\n                    border: dashed 1px $gray-blue-40;\r\n                    border-radius: 6px;\r\n                    transition-duration: 0.2s;\r\n\r\n                    > div {\r\n                        transform: scale(0.9);\r\n                    }\r\n                    .fa-cog {\r\n                        opacity: 0.7;\r\n\r\n                        &:hover {\r\n                            opacity: 1;\r\n                        }\r\n                    }\r\n                }\r\n                .fa-cog {\r\n                    opacity: 0;\r\n                }\r\n                > div {\r\n                    display: flex;\r\n                    align-items: center;\r\n                    gap: 12px;\r\n                }\r\n                .grouped-items {\r\n                    display: inline-flex;\r\n                    flex-direction: column;\r\n                    \r\n                    span.db-group-name {\r\n                        display: -webkit-box;\r\n                        overflow: hidden;\r\n                        -webkit-box-orient: vertical;\r\n\r\n                        &:first-child {\r\n                            -webkit-line-clamp: 1;\r\n                        }\r\n                        &:last-child {\r\n                            -webkit-line-clamp: 2;\r\n                        }\r\n                    }\r\n                }\r\n                @media screen and (max-width: 520px) {\r\n                    .db-image {\r\n                        display: none;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.text-color {\r\n    color: $text-color;\r\n}\r\n.page-name-bar {\r\n    &.json-schema-editor-page,\r\n    &.service-create {\r\n        margin-top: -13px;\r\n        margin-bottom: 10px;\r\n\r\n        > .col-md-6 {\r\n            &:first-child {\r\n                &:not(:empty) {\r\n                    display: flex;\r\n                    align-items: center;\r\n                }\r\n            }\r\n        }\r\n        button {\r\n            &.btn {\r\n                &.btn-celia {\r\n                    span {\r\n                        line-height: 12px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        .dropdown {\r\n            &:last-child {\r\n                button {\r\n                    &.btn-outline-danger {\r\n                        margin-inline-end: 0;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.page-name {\r\n    > span {\r\n        display: flex;\r\n        align-items: center;\r\n        width: 100%;\r\n\r\n        .jr-btn {\r\n            margin-inline-start: 12px;\r\n            \r\n            border-color: rgba(27, 37, 95, 1);\r\n\r\n            &.round-add {\r\n                height: 25px;\r\n                padding: 0 5px !important;\r\n                border-radius: 20px !important;\r\n\r\n                i {\r\n                    font-size: 13px;\r\n                    font-weight: 700;\r\n                    width: 12px;\r\n                }\r\n            }\r\n        }\r\n        .badge {\r\n            margin: 0 18px;\r\n        }\r\n    }\r\n    .audit-log-heading {\r\n        .db-options-buttons {\r\n            align-items: center;\r\n            gap: 10px;\r\n            line-height: 1;\r\n\r\n            .jr-menu-icon {\r\n                width: auto !important;\r\n                border: solid 1px $gray-blue-10;\r\n                border-radius: 6px;\r\n                padding: 0 !important;\r\n                height: 32px !important;\r\n          \r\n                > span {\r\n                    padding: 0 0.8rem;\r\n                    color: $gray-blue-40;\r\n                    font-size: 13px;\r\n                    font-weight: 500;\r\n          \r\n                    &.tools-off {\r\n                        color: $gray-blue-100;\r\n                        background-color: $gray-blue-10;\r\n                    }\r\n                }\r\n                &.options--opened {\r\n                    > span {\r\n                        &.tools-on {\r\n                            color: $gray-blue-100;\r\n                            background-color: $gray-blue-10;\r\n                        }\r\n                        &.tools-off {\r\n                            color: $gray-blue-40;\r\n                            background-color: transparent;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            span {\r\n                font-weight: 700;\r\n                color: #3E73A5;\r\n                font-size: 14px;\r\n            }\r\n            i.toggle-icon {\r\n                color: #BABDCE;\r\n                font-size: 20px;\r\n                cursor: pointer;\r\n          \r\n                &.fa-toggle-on {\r\n                    color: #3fac82;\r\n                }\r\n                &:hover {\r\n                    color: #a2bbd4;\r\n                }\r\n            }\r\n        }\r\n        .search--table {\r\n            transition: all .2s;\r\n            border-bottom: solid 1px #f4f4f4;\r\n            color: white;\r\n            display: inline-flex;\r\n            width: auto;\r\n            align-items: center;\r\n            height: 32px;\r\n            background-color: #EAEDF2;\r\n            border-radius: 6px;\r\n            padding: 0 12px;\r\n\r\n            &:hover,\r\n            &:focus,\r\n            &:focus-within {\r\n                transition: all .2s;\r\n                opacity: 1;\r\n            }\r\n            input {\r\n                border: none;\r\n                display: flex;\r\n                background: transparent;\r\n                width: 100%;\r\n                color: $text-color-80;\r\n                font-size: 13px;\r\n                font-weight: 500;\r\n\r\n                &:focus,\r\n                &:active {\r\n                    outline: none;\r\n                }\r\n            }\r\n            i {\r\n                display: inline-flex;\r\n                color: $text-color-80;\r\n                font-size: 14px;\r\n            }\r\n        }\r\n    }\r\n}\r\n.page-name-section {\r\n    .db-name-container {\r\n        margin-bottom: 17px !important;\r\n        text-transform: uppercase;\r\n\r\n        &:empty {\r\n            display: none;\r\n\r\n            & + .page-name-bar {\r\n                --custom-bottom-margin: 17px;\r\n            }\r\n        }\r\n    }\r\n}",".react-table {\n    .rt-table {\n        background-color: $white;\n\n        .rt-thead {\n            min-width: fit-content;\n            .tr {\n                .th {\n                    display: flex;\n\n                    &.type-number {\n                        justify-content: flex-end;\n\n                        .sorted-arrow {\n                            margin-inline-start: 6px;\n\n                            &:empty {\n                                display: none;\n                            }\n                        }\n                    }\n                    span {\n                        &.sorted-arrow {\n                            margin-inline-start: auto;\n                        }\n                    }\n                }\n                & + .tr {\n                    .th {\n                        span {\n                            &:first-child {\n                                flex: auto;\n                                z-index: 99;\n                            }\n                            &.sorted-arrow {\n                                align-items: center;\n                                display: inline-flex;\n                                margin-inline-start: -6px;\n                            }\n                        }\n                        &.type-number {\n                            justify-content: flex-end;\n    \n                            span {\n                                &:first-child {\n                                    flex: initial;\n                                    text-align: end;\n                                }\n                                &.sorted-arrow {\n                                    margin-inline-start: 6px !important;\n        \n                                    &:empty {\n                                        display: none;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n                &:only-child {\n                    .th {\n                        text-transform: initial;\n                    }\n                }\n            }\n        }\n        .rt-tbody {\n            > div {\n                min-width: fit-content;\n            }\n            .tr {\n                &.selected-row {\n                    .td {\n                        background: #e5e5e5;\n                    }\n                }\n                .td {\n                    &:is(.type-array_of_file, .type-file) {\n                        display: flex;\n                        padding-block: 0;\n                        padding-inline: 0;\n                        align-items: center;\n\n                        &:not(:has(button)) {\n                            padding-inline: 12px;\n                        }\n                    }\n\n                    &.type-number {\n                        text-align: end;\n                        justify-content: flex-end;\n                    }\n                    button {\n                        &.btn {\n                            &.btn-link {\n                                border: none;\n                                height: auto;\n                                overflow: hidden;\n                                text-overflow: ellipsis;\n                                display: inline-block;\n                            }\n                        }\n                    }\n                    &.editgrid-cell {\n                        button {\n                            align-items: center;\n                            display: inline-flex;\n                            line-height: 1;\n                            height: 21px !important;\n                            gap: 2px;\n                            margin-inline-start: -0.75rem;\n\n                            & + button {\n                                margin-inline-start: 0;\n                                padding: 0 0.5rem;\n                            }\n                            &:hover {\n                                background-color: $black-5;\n                                color: $black;\n                            }\n                        }\n                    }\n                }\n                &:hover {\n                    .table-row-actions-cell {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n        .rt-tfoot {\n            .tr {\n                .td {\n                    justify-content: flex-end;\n                }\n            }\n        }\n    }\n}\n.app-container {\n    &.translations-page {\n        .app-main-content {\n            min-height: 100px;\n\n            .app-wrapper {\n                height: calc(100% - 8px);\n                flex-direction: row;\n                display: flex;\n\n                .dashboard.translations-page {\n                    height: 100%;\n                    display: flex;\n                    flex-grow: 1;\n                    flex-direction: column;\n                    min-height: 100px;\n\n                    .translations-table-container {\n                        flex: auto;\n                        display: flex;\n                        flex-direction: column;\n                        min-height: 100px;\n                        height: calc(100vh - 254px);\n                        padding-top: 24px;\n\n                        .translations-table {\n                            max-height: 100%;\n\n                            .rt-table {\n                                max-height: calc(100% - 52px) !important;\n                                overflow-x: hidden !important;\n                            }\n\n                            .pagination {\n                                position: relative;\n                            }\n                        }\n                    }\n                    > .card {\n                        border: none;\n                        margin-top: 16px;\n\n                        > .card-header {\n                            padding: 0;\n                            min-height: 42px;\n                            background-color: transparent !important;\n                            border-bottom: none;\n\n                            .nav-tabs {\n                                margin: 0;\n                                height: 100%;\n\n                                .nav-item {\n                                    flex: initial;\n                                }\n                            }\n                        }\n                        .tab-content {\n                            background: #f2f2f2;\n                            box-shadow: -50vw 0 0 #f2f2f2, 50vw 0 0 #f2f2f2;\n                            padding-top: 20px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}",".mb-7 {\n    margin-bottom: 5rem !important;\n}\n.collapse-panel-icon {\n    margin-inline-start: var(--left-margin, auto);\n}\n.duplicate-db-button + .collapse-panel-icon {\n    --left-margin: 0px;\n}",".app-sidebar {\r\n    .side-nav {\r\n        width: 100%;\r\n        transition-duration: 0.3s;\r\n        font-family: $font-family-sans-serif;\r\n\r\n        .sidebar-header {\r\n            border: none;\r\n\r\n            .instance-logo-container {\r\n                & + div {\r\n                    i {\r\n                        font-size: 20px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.group-opened {\r\n        .side-nav {\r\n            .drawer-dbs-groups {\r\n                .SplitPane {\r\n                    .Pane2 {\r\n                        opacity: 1;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        .modal-content {\r\n            > div {\r\n                > div {\r\n                    &[style=\"width: 25vw;\"] {\r\n                        width: 50vw;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &:not(.group-opened) {\r\n        .drawer-dbs-groups {\r\n            .SplitPane {\r\n                .Pane1 {\r\n                    width: 100% !important;\r\n                }\r\n                .Pane2 {\r\n                    opacity: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .sidebar-draggable-area {\r\n        > div {\r\n            margin-bottom: 22px !important;\r\n        }\r\n    }\r\n    ul.nav-menu.db-list-menu {\r\n        height: max-content;\r\n        padding-bottom: 22px;\r\n    }\r\n}\r\n\r\n.manage-version-drawer {\r\n    .card {\r\n        margin-bottom: var(--custom-margin-bottom, 1rem);\r\n        border: none;\r\n\r\n        &:last-child {\r\n            --custom-margin-bottom: 0px;\r\n        }\r\n    }\r\n    .card-header {\r\n        background-color: var(--card-header-bg-color, #ECF1F5);\r\n        padding: 12px 24px;\r\n        border: none;\r\n        border-radius: 6px;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        position: relative;\r\n    }\r\n    :where(.trash-button, .card-header) {\r\n        line-height: 1;\r\n    }\r\n    .accordion {\r\n        .card-body {\r\n            padding: 0px;\r\n        }\r\n    }\r\n    .accordion-collapse.show {\r\n        padding-top: 10px;\r\n        transition-duration: 0.15s;\r\n    }\r\n    .service-item {\r\n        border-bottom: solid 1px #DBDBDB;\r\n        padding: 10px 24px;\r\n        display: flex;\r\n        gap: 10px;\r\n        align-items: center;\r\n\r\n        &:last-child {\r\n            border-bottom: none;\r\n        }\r\n    }\r\n    .service-name {\r\n        flex: 0 0 50%;\r\n    }\r\n    .service-date {\r\n        flex: 1;\r\n    }\r\n    .service-action {\r\n        margin-inline-end: -6px;\r\n    }\r\n}",".modal {\r\n    &.no-overlay,\r\n    &.no-overlay + .modal-backdrop {\r\n        bottom: initial;\r\n    }\r\n}",".type-select-style {\r\n    [class*=\"-menu\"] {\r\n        z-index: 10;\r\n    }\r\n}\r\n\r\n/* Advanced settings */\r\n.json-schema-react-editor-adv-modal {\r\n    .all-advanced-visible-switch {\r\n        display: flex;\r\n\r\n        button {\r\n            .ant-switch-inner {\r\n                line-height: 1;\r\n            }\r\n        }\r\n    }\r\n    .modal-header {\r\n        background-color: white !important;\r\n        border: none !important;\r\n\r\n        .modal-title {\r\n            & > div {\r\n                display: flex;\r\n                align-items: center;\r\n                gap: 1rem;\r\n            }\r\n        }\r\n    }\r\n    .modal-content {\r\n        border: none;\r\n\r\n        .modal-body {\r\n            height: calc(100vh - 180px);\r\n            padding: 0px;\r\n\r\n            > div:not(.ant-tabs) {\r\n                padding: 28px;\r\n            }\r\n            .other-row {\r\n                .ant-col {\r\n                    .other-row {\r\n                        padding: 0;\r\n                    }\r\n                }\r\n            }\r\n            .fk-settings-container .other-row {\r\n                padding: 0px;\r\n                margin-bottom: 0px;\r\n            }\r\n            .fk-settings {\r\n                .fk-item-checkbox {\r\n                    display: none;\r\n                }\r\n            }\r\n            .advanced-toggle-row {\r\n                display: flex;\r\n                align-items: center;\r\n                gap: 20px;\r\n                padding: 0px 0px 29px;\r\n                margin: 0px;\r\n            }\r\n            .ant-row-flex {\r\n                gap: 12px;\r\n\r\n                .ant-col {\r\n                    flex: 1;\r\n                }\r\n                .ant-col-2 {\r\n                    flex: 2;\r\n                }\r\n                .ant-col-3 {\r\n                    flex: 3;\r\n                }\r\n                .ant-col-8 {\r\n                    flex: 8;\r\n                    max-width: 33.33%;\r\n                }\r\n                .ant-col-11 {\r\n                    flex: 11;\r\n                }\r\n                .ant-col-12 {\r\n                    flex: 12;\r\n                    max-width: 50%;\r\n                }\r\n                .ant-col-16 {\r\n                    flex: 16;\r\n                    max-width: 66.66%;\r\n                }\r\n                .ant-col-24 {\r\n                    flex: 24;\r\n                }\r\n            }\r\n        }\r\n        .modal-footer {\r\n            background-color: white !important;\r\n            border-top: none !important;\r\n        }\r\n        .schema-trigger {\r\n            > button.ant-btn {\r\n                border-radius: 6px !important;\r\n                border: solid 1px #4678AA !important;\r\n                color: #4678AA;\r\n                background-color: white;\r\n\r\n                &:hover {\r\n                    background-color: #4678AA;\r\n                    color: white;\r\n                }\r\n            }\r\n            .trigger-item {\r\n                position: relative;\r\n\r\n                > div:first-child {\r\n                    .ant-btn.danger {\r\n                        height: 28px;\r\n                        line-height: 20px;\r\n                        border-radius: 6px;\r\n                        border-color: #f44336;\r\n                        color: #f44336;\r\n\r\n                        &:hover {\r\n                            background-color: #f44336;\r\n                            color: #FFFFFF;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .ant-col {\r\n        .other-label {\r\n            span {\r\n                margin-bottom: 10px;\r\n            }\r\n        }\r\n    }\r\n}\r\n.advanced-toggle-row {\r\n    &::before,\r\n    &::after {\r\n        display: none;\r\n    }\r\n    .ant-switch {\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n}\r\n.fk-settings {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    padding: 0px !important;\r\n}\r\n.fk-item-action {\r\n    white-space: nowrap;\r\n}","\r\n.delete-popover {\r\n    .popover {\r\n        border-radius: 6px;\r\n        border: 1px solid $red-color-a-20;\r\n        box-shadow: 0 0.25rem 0.5rem $red-color-a-10;\r\n        max-width: 500px;\r\n    \r\n        .arrow {\r\n            &::before {\r\n                border-bottom-color: $red-color-a-20;\r\n            }\r\n        }\r\n    }\r\n    .buttons-area {\r\n        display: flex;\r\n        gap: 10px;\r\n    }\r\n}",".app-container {\r\n    &.read-value-view-page {\r\n        .app-toolbar {\r\n            .topbar-logo-container {\r\n                position: absolute;\r\n                width: 100%;\r\n                inset-inline-start: 0;\r\n                justify-content: center;\r\n            }\r\n        }\r\n    }\r\n    .database-metadata {\r\n        text-align: start;\r\n\r\n        .general-info {\r\n            &.institution {\r\n                font-size: 22px;\r\n                margin-bottom: 8px;\r\n                line-height: 1.2;\r\n            }\r\n            &.description {\r\n                font-size: 16px;\r\n            }\r\n        }\r\n    }\r\n    .field-tree {\r\n        &:not(:first-child) {\r\n            margin-top: 1rem;\r\n        }\r\n        .data-read-value-field {\r\n            margin-inline-start: 16px;\r\n\r\n            .field-value {\r\n                font-size: 24px;\r\n                line-height: 1.2;\r\n                font-weight: 500;\r\n            }\r\n            .field-description {\r\n                margin-top: 6px;\r\n            }\r\n        }\r\n    }\r\n}\r\n.row-history {\r\n    .json-data-view-object-item {\r\n        tbody {\r\n            tr {\r\n                td {\r\n                    padding: 0;\r\n                    min-height: 48px;\r\n                    --cell-vertical-align: middle;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .data-read-value-field {\r\n        --left-margin: -24px;\r\n        --right-margin: -24px;\r\n        margin-inline-end: var(--right-margin);\r\n        margin-bottom: -24px;\r\n    }\r\n    .field-value {\r\n        > .json-data-view-object-item {\r\n            > tbody {\r\n                > tr:not(.field-type-object) {\r\n                    > td {\r\n                        &:first-child {\r\n                            padding-inline-start: 24px;\r\n                        }\r\n                        &:last-child {\r\n                            padding-inline-end: 24px;\r\n                        }\r\n                    }\r\n                }\r\n                > tr.field-type-object {\r\n                    > .item-value-cell > .json-data-view-object-item > tbody > tr:not(.field-type-object) > td:last-child {\r\n                        padding-inline-end: 24px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .field-history-icon-container {\r\n        margin-inline-end: 0px !important;\r\n    }\r\n    .item-fieldname-cell label {\r\n        padding-top: 0px;\r\n    }\r\n}\r\n.field-history-page-container {\r\n    box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);\r\n    border-radius: 10px;\r\n    padding: 1.5rem 1.5rem 3rem;\r\n\r\n    .react-table .rt-table {\r\n        max-height: calc(100vh - 360px);\r\n    }\r\n}\r\n.field-tree-list,\r\n.file-list {\r\n    list-style: none;\r\n    padding-inline-start: 0;\r\n    margin-bottom: 16px;\r\n}\r\n.file-list {\r\n    margin-bottom: 0;\r\n}\r\n.tree-level-icon {\r\n    position: relative;\r\n    top: -3px;\r\n    margin-inline-end: 6px;\r\n}\r\n.field-name {\r\n    margin-inline-start: 6px;\r\n}\r\nli {\r\n    &:first-child {\r\n        .tree-level-icon {\r\n            top: initial;\r\n        }\r\n    }\r\n    &:only-child {\r\n        .tree-level-icon {\r\n            display: none;\r\n        }\r\n    }\r\n    &:last-child {\r\n        .field-name {\r\n            font-weight: 600;\r\n            margin-inline-end: 6px;\r\n        }\r\n    }\r\n}",".data-view-list-group {\n    margin-top: 24px;\n    .data-view-list-group-title {\n    \n        text-align: start;\n        margin-bottom: 12px;\n        span {\n            font: normal 600 16px / 20px Open Sans, sans-serif;\n            letter-spacing: -0.002em;\n            color: #121212;\n            font-weight: 600;\n        }\n        i {\n            font-size: var(--button-icon-size, 13px);\n            padding: 2px;\n            min-width: var(--button-icon-square-size, 16px);\n            min-height: var(--button-icon-square-size, 16px);\n            --button-icon-size: 13px;\n            margin-inline-end: 8px;\n        }\n    }\n    \n    &.list-collapsed {\n        .data-view-list-table {\n            display: none;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
